import { useWalletModal } from '@ui/components/WalletModal/useWalletModal';
import { getChainName } from '@ui/constants/chain';
import { useDataChainId, useIsWrongNetwork } from '@ui/hooks/datachain';
import { useSwitchChain } from '@ui/hooks/useSwitchChain';
import { ButtonProps } from '@ui/lib/park/ui/button';
import { useTranslation } from 'next-i18next';
import { cloneElement, ReactElement, useState } from 'react';
import { useAccount } from 'wagmi';

export const RequireConnectionClickable = ({
  children,
  ...props
}: ButtonProps & {
  children: ReactElement;
}): ReactElement => {
  const { t } = useTranslation();

  const { isConnected } = useAccount();

  const isWrongNetwork = useIsWrongNetwork();
  const { switchChain, isPending } = useSwitchChain();
  const dataChainId = useDataChainId();
  const { open } = useWalletModal();

  if (isConnected) {
    if (isWrongNetwork) {
      return cloneElement<ButtonProps>(children, {
        ...props,
        loading: isPending,
        children: t('common.Switch to {chainName}', {
          chainName: getChainName(dataChainId),
        }),
        onClick: () => {
          switchChain(dataChainId);
        },
      });
    }

    return cloneElement(children, props);
  }

  // not connected, override onClick
  return (
    <>
      {cloneElement(children, {
        ...props,
        onClick: () => {
          open();
        },
      })}
    </>
  );
};
